// import RouterProvider from "@routers/index";
import GlobalLoading from "@/components/GlobalLoading";
import GlobalMessage from "@/components/GlobalMessage";
import InstallPrompt from "@/components/InstallPrompt";
import OfflineIndicator from "@/components/OfflineIndicator";
import { usePageVisitLogger } from "@/hooks/usePageVisitLogger";
import BetaBanner from "@views/BetaBanner";
import MainBreadcrumb from "@views/Breadcrumb";
import MainHeader from "@views/MainHeader";
import MainSider from "@views/MainSider";
import { StyledContent } from "@views/styled";
import { FloatButton, Layout, theme } from "antd";
import { useRef } from "react";
import { Outlet } from "react-router-dom";

function MainLayout() {
  const contentRef = useRef<HTMLElement>(null);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  usePageVisitLogger();

  return (
    <Layout>
      <BetaBanner />
      <OfflineIndicator />
      <MainHeader />
      <Layout>
        <MainSider style={{ background: colorBgContainer }} />
        <Layout>
          <MainBreadcrumb />
          <StyledContent ref={contentRef}>
            <Outlet />
          </StyledContent>
        </Layout>
      </Layout>
      <GlobalMessage />
      <GlobalLoading />
      <InstallPrompt />
      <FloatButton.BackTop
        target={() => contentRef.current!}
        style={{
          bottom: 75,
        }}
      />
    </Layout>
  );
}

export default MainLayout;
